/** Preserve the legacy range, including equal start and current years. */
export function formatCopyrightYears(yearFrom: string): string {
  const currentYear = new Date().getFullYear();
  return yearFrom === "" ? String(currentYear) : `${yearFrom} - ${currentYear}`;
}
